/// /////////////////////////////////////////////////////////////////////
const fontStyles = {
  fontFamily: 'Inter, sans-serif',
  fontSize: '16px',
  lineHeight: '24px'
};

export { fontStyles };
